<template>
  <div class="modal-box">
    <div class="modal-title">
      <h3>Bewerk ruimte
      </h3>
      <div class="flex-divider"></div>
      <base-button
        type="secondary"
        @click="closeModal"
      >
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content">
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Basisgegevens</h4>
        </div>
        <div class="input-container">
          <label
            class="label required"
            for="roomName"
          >Ruimtenaam</label>
          <base-input
            type="text"
            id="roomName"
            name="roomName"
            v-model="roomBody.roomName"
            data-vv-as="Ruimtenaam"
            v-validate="'required'"
          />
          <base-input-warning :error="errors.first('roomName')" />
        </div>
        <div class="input-container">
          <label
            for
            class="label"
          >Beschrijving</label>
          <textarea
            class="input"
            v-model="roomBody.description"
          ></textarea>
        </div>
      </div>
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Eigenschappen</h4>
        </div>
        <div class="input-container">
          <label
            class="label required"
            for="roomType"
          >Ruimtesoort</label>
          <select
            id="roomType"
            name="roomType"
            class="input"
            v-bind:value="roomBody.type"
            @change="roomBody.type = $event.target.value"
            data-vv-as="Ruimtesoort"
            v-validate="'required'"
          >
            <option
              v-for="option in roomTypeOptions"
              :key="option.id"
              :value="option.id"
            >{{option.label}}</option>
          </select>
          <base-input-warning :error="errors.first('roomType')" />
        </div>
        <div class="input-row">
          <div class="input-container">
            <label
              class="label required"
              for="roomWidth"
            >Breedte (m)</label>
            <base-input
              id="roomWidth"
              name="roomWidth"
              type="number"
              placeholder="0"
              v-model="roomBody.width"
              data-vv-as="Breedte"
              v-validate="'required'"
              step="0.1"
            />
            <base-input-warning :error="errors.first('roomWidth')" />
          </div>
          <div class="input-container">
            <label
              class="label required"
              for="roomLength"
            >Lengte (m)</label>
            <base-input
              id="roomLength"
              name="roomLength"
              type="number"
              placeholder="0"
              v-model="roomBody.length"
              data-vv-as="Lengte"
              v-validate="'required'"
              step="0.1"
            />
            <base-input-warning :error="errors.first('roomLength')" />
          </div>
          <div class="input-container">
            <label
              class="label required"
              for="roomHeight"
            >Hoogte (m)</label>
            <base-input
              id="roomHeight"
              name="roomHeight"
              type="number"
              placeholder="0"
              v-model="roomBody.height"
              data-vv-as="Hoogte"
              v-validate="'required'"
              step="0.1"
            />
            <base-input-warning :error="errors.first('roomHeight')" />
          </div>
        </div>
        <!-- <div class="input-row">
          <div class="input-container">
            <label
              class="label required"
              for="peopleAmount"
            >Aantal personen</label>
            <base-input
              id="peopleAmount"
              name="peopleAmount"
              type="number"
              placeholder="0"
              v-model="roomBody.people.amount"
              data-vv-as="Aantal personen"
              v-validate="'required'"
              step="1"
            />
            <base-input-warning :error="errors.first('peopleAmount')" />
          </div>
          <div class="input-container">
            <label class="label required">Gedrag personen</label>
            <select
              class="input"
              v-bind:value="roomBody.people.type"
              @change="roomBody.people.type = $event.target.value"
              name="peopleType"
              data-vv-as="Gedrag personen"
              v-validate="'required'"
            >
              <option
                v-for="option in $peopleTypes"
                :key="option.value"
                :value="option.value"
              >{{option.label}}</option>
            </select>
            <base-input-warning :error="errors.first('peopleType')" />
          </div>
        </div> -->
        <div class="input-row">
          <div class="input-container">
            <label class="label required">Interieur</label>
            <select
              class="input"
              v-bind:value="roomBody.interior"
              @change="roomBody.interior = $event.target.value"
              name="interior"
              data-vv-as="Interieur"
              v-validate="'required'"
            >
              <option
                v-for="option in $interiors"
                :key="option.value"
                :value="option.value"
              >{{option.label}}</option>
            </select>
            <base-input-warning :error="errors.first('interior')" />
          </div>
          <div class="input-container">
            <label class="label required">Extra wensen</label>
            <select
              class="input"
              v-bind:value="roomBody.wishes"
              @change="roomBody.wishes = $event.target.value"
              name="wishes"
              data-vv-as="Extra wensen"
              v-validate="'required'"
            >
              <option
                v-for="option in $wishes"
                :key="option.value"
                :value="option.value"
              >{{option.label}}</option>
            </select>
            <base-input-warning :error="errors.first('wishes')" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <base-button
        @click="deleteRoom"
        type="danger"
        :loading="deletingRoom"
        :disabled="deletingRoom || editingRoom"
      >Verwijderen</base-button>
      <div class="flex-divider"></div>
      <base-button
        @click="closeModal"
        type="secondary"
      >Annuleren</base-button>
      <base-button
        @click="editRoom"
        :loading="editingRoom"
        :disabled="editingRoom || deletingRoom"
      >
        <base-icon
          iconRef="save"
          position="left"
        />Opslaan
      </base-button>
    </div>
  </div>
</template>

<script>
import Firebase from "firebase";

export default {
  name: "room-edit-modal",
  data: function() {
    return {
      currentRoomTypeUpToDate: null,
      deletingRoom: false,
      editingRoom: false,
      roomBody: {
        roomName: "",
        description: "",
        height: "",
        width: "",
        length: "",
        type: "",
        interior: "",
        people: {
          type: "",
          amount: ""
        },
        wishes: ""
      }
    };
  },
  computed: {
    roomTypeOptions: function() {
      return this.$store.getters.getActiveAdvicevaluesList;
    },
    allRoomTypeOptions: function() {
      return this.$store.getters.getAdvicevaluesList;
    },
    currentRoomType: function() {
      return this.allRoomTypeOptions.find(
        roomType => roomType.id == this.currentRoom.data().type
      );
    },
    currentRoom: function() {
      return this.$store.getters.getCurrentClientPage.room;
    },
    currentProject: function() {
      return this.$store.getters.getProjectsList.find(project => {
        return project.id == this.currentRoom.data().belongsTo;
      });
    }
  },
  methods: {
    editRoom: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.editingRoom = true;
          const roomData = {
            id: this.currentRoom.id,
            body: this.$editRoomDataObject(this.roomBody)
          };
          Firebase.firestore()
            .collection("rooms")
            .doc(roomData.id)
            .update(roomData.body)
            .then(() => {
              Firebase.firestore()
                .collection("rooms")
                .doc(roomData.id)
                .get()
                .then(doc => {
                  this.$store.commit("setCurrentClientPageRoom", doc);
                  this.editingRoom = false;
                  this.closeModal();
                });
            });
        }
      });
    },
    deleteRoom: function() {
      this.$dialog.confirm({
        message: `Weet je zeker dat je de klant:
        <p class="dialog-attention">${this.currentRoom.data().clientName}</p>
        wilt verwijderen?`,
        cancelText: "Annuleer",
        confirmText: "Verwijder",
        type: "is-danger",
        onConfirm: () => {
          this.deletingRoom = true;
          const roomData = {
            id: this.currentRoom.id,
            body: this.$deleteRoomDataObject()
          };
          this.$store.dispatch("editRoom", roomData).then(() => {
            this.deletingRoom = false;
            this.closeModal();
            this.$router.push(`/klant/${this.currentProject.id}`);
          });
        }
      });
    },
    closeModal: function() {
      this.$store.commit("setModalShown", {
        dataType: "room",
        modalType: "edit",
        shown: false
      });
    }
  },
  mounted: function() {
    this.roomBody = Object.assign({}, this.currentRoom.data());
    if (
      this.roomTypeOptions.find(
        roomType => roomType.id == this.currentRoom.data().type
      )
    ) {
      this.currentRoomTypeUpToDate = true;
    } else {
      const fallbackOption = document.createElement("option");
      fallbackOption.text = this.currentRoomType.label;
      fallbackOption.value = this.currentRoomType.id;
      fallbackOption.selected = true;
      fallbackOption.disabled = true;
      document.querySelector("#roomType").appendChild(fallbackOption);
      this.currentRoomTypeUpToDate = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/room-edit-modal.vue